import { createStore } from 'vuex'

export default createStore({
  state: {
    bannerHeight:'600',
    navBgColor:'rgb(0 0 0 / 0%)',
  },
  getters: {
  },
  mutations: {
    setbannerHeight(state:any,height:string){
      state.bannerHeight = height
    },
    setnavBgColor(state:any,color:string){
      state.navBgColor = color
    },
  },
  actions: {
  },
  modules: {
  }
})
